import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {NotificationBaseApiDto, LeadWatcherChangeNotificationDataApiDto} from "../../../api/model/rest";
import {getUser} from "../../../store/view/user";
import LeadWatcherChangeNotificationData from "./LeadWatcherChangeNotificationData";

/**
 * Lead watcher change notification class.
 */
export default class LeadWatcherChangeNotification extends NotificationBase {

	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: LeadWatcherChangeNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): LeadWatcherChangeNotification {
		return new LeadWatcherChangeNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			LeadWatcherChangeNotificationData.fromJson(json.data as LeadWatcherChangeNotificationDataApiDto));
	}

	/**
	 * Display user Full name.
	 * @returns {string}
	 */
	displayCreatorName() {
		return getUser(this.data.creator.id).map(u => u.getDisplayName()).getOrElse(this.data.creator.id);
	}

	/**
	 * Display previous watchers full names
	 * @return {string[]}
	 */
	displayPreviousWatchers() {
		 let previousWatchers = this.data.previousWatchersIds.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("")).join(", ");
		 return previousWatchers ? previousWatchers : "No watchers";
	}

	/**
	 * Display current watchers full names
	 * @return {string[]}
	 */
	displayCurrentWatchers() {
		let currentWatchers = this.data.currentWatchersIds.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("")).join(", ");
		return currentWatchers ? currentWatchers : "No watchers";
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new LeadWatcherChangeNotification(id, dateTime, read, type, data);
	}
}